<template>
  <v-container fluid class="pa-0">
    <v-row>
      <v-col cols="12">
        <div class="d-flex align-center mb-4">
          <v-icon color="primary" large class="mr-3">mdi-email-edit-outline</v-icon>
          <div>
            <h2 class="text-h4 font-weight-bold white--text">Signatur Generator</h2>
            <p class="body-2 grey--text text--lighten-1 mb-0">Erstelle den HTML-Code für deine Outlook- oder Hostpoint-Signatur.</p>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="5" lg="4">
        <v-card class="pa-6" color="#1E1E1E" elevation="4" rounded="lg">
          <h3 class="text-h6 font-weight-bold mb-4 white--text">
            <v-icon left color="primary">mdi-account-details</v-icon>
            1. Daten eingeben
          </h3>

          <label class="caption font-weight-bold grey--text text--lighten-1 ml-1">Marke wählen</label>
          <v-radio-group v-model="form.brand" row class="mt-1 mb-2">
            <v-radio label="WINTI FIT" value="winti" color="success" dark></v-radio>
            <v-radio label="WELL COME FIT" value="wellcome" color="success" dark></v-radio>
          </v-radio-group>

          <v-text-field v-model="form.name" label="Vorname Nachname" filled rounded dark hide-details="auto" class="mb-4"></v-text-field>
          <v-text-field v-model="form.role" label="Funktion / Rolle" filled rounded dark hide-details="auto" class="mb-4"></v-text-field>

          <v-divider class="grey darken-3 my-5"></v-divider>

          <v-text-field v-model="form.street" label="Strasse & Nr." filled rounded dark hide-details="auto" class="mb-4"></v-text-field>
          <v-text-field v-model="form.city" label="PLZ & Ort" filled rounded dark hide-details="auto" class="mb-4"></v-text-field>

          <label class="caption font-weight-bold grey--text text--lighten-1 ml-1">Kontaktdaten</label>
          <v-text-field v-model="form.email" label="E-Mail Adresse" filled rounded dark hide-details="auto" class="mb-4"></v-text-field>

          <v-radio-group v-model="form.phoneLabel" row class="mt-0 mb-2" hide-details>
            <v-radio label="Center" value="Center" color="success" dark></v-radio>
            <v-radio label="Büro" value="Büro" color="success" dark></v-radio>
          </v-radio-group>
          <v-text-field v-model="form.phone" label="Telefonnummer" filled rounded dark></v-text-field>
        </v-card>
      </v-col>

      <v-col cols="12" md="7" lg="8">
        <div class="sticky-top">
          <v-card class="pa-6" color="#1E1E1E" elevation="4" rounded="lg">
            <h3 class="text-h6 font-weight-bold mb-4 white--text">
              <v-icon left color="primary">mdi-code-tags</v-icon>
              2. HTML-Code herunterladen
            </h3>

            <v-alert
              color="info"
              border="left"
              elevation="2"
              colored-border
              icon="mdi-information"
              class="mb-6 white--text"
              style="background-color: rgba(33, 150, 243, 0.1)">
              <div class="font-weight-bold text-subtitle-1 mb-1">So fügst du die Signatur ein:</div>
              <ol class="body-2 ml-4" style="line-height: 1.6">
                <li>Lade die Textdatei unten herunter und öffne sie.</li>
                <li>Kopiere den <strong>gesamten Code</strong> (Strg + A, dann Strg + C).</li>
                <li>Gehe in dein E-Mail-Programm (z.B. Hostpoint Webmail).</li>
                <li>
                  WICHTIG: Klicke im Editor auf den Button
                  <v-chip x-small color="grey darken-3" class="px-2 mx-1 white--text font-weight-bold">&lt; &gt;</v-chip>
                  oder <strong>"Quellcode"</strong>.
                </li>
                <li>Füge den Code dort ein und speichere ab.</li>
              </ol>
            </v-alert>

            <v-btn block color="#00943c" x-large dark elevation="4" @click="downloadTextFile" class="font-weight-bold rounded-lg mb-6">
              <v-icon left>mdi-file-download</v-icon>
              Signatur herunterladen
            </v-btn>

            <div class="white pa-6 rounded-lg overflow-hidden">
              <div style="color: #666; font-size: 11px; margin-bottom: 20px; border-bottom: 1px solid #eee">VORSCHAU DES ERGEBNISSES:</div>
              <div v-html="generateSignatureHTML()"></div>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    form: {
      brand: "wellcome", // winti oder wellcome
      name: "",
      role: "",
      street: "",
      city: "",
      email: "",
      phoneLabel: "",
      phone: "",
    },
  }),
  methods: {
    // Hilfsfunktion: Wandelt Sonderzeichen sicher um
    escapeHtml(text) {
      if (!text) return ""
      const map = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;",
        ä: "&auml;",
        ö: "&ouml;",
        ü: "&uuml;",
        Ä: "&Auml;",
        Ö: "&Ouml;",
        Ü: "&Uuml;",
        ß: "&szlig;",
      }
      return text.toString().replace(/[&<>"'äöüÄÖÜß]/g, (m) => map[m])
    },
    generateSignatureHTML() {
      // 1. Logik für Brand-Name
      const brandTextHtml =
        this.form.brand === "winti"
          ? '<span style="color: #000000;">WINTI</span> <span style="color: #00943c;">FIT</span>'
          : '<span style="color: #000000;">WELL COME</span> <span style="color: #00943c;">FIT</span>'

      const phoneClean = this.form.phone.replace(/\s/g, "")

      // Bild-URLs
      const logoUrl = "https://app.wellcomefit.ch/img/logos/studio/WELL-COME-FIT_LOGO_WHITE.png"
      const bannerUrl = "https://app.wellcomefit.ch/img/einmalig/signatur.png"

      // 2. Eingaben sicher machen
      const safeName = this.escapeHtml(this.form.name)
      const safeRole = this.escapeHtml(this.form.role)
      const safeStreet = this.escapeHtml(this.form.street)
      const safeCity = this.escapeHtml(this.form.city)
      const safePhoneLabel = this.escapeHtml(this.form.phoneLabel)

      // 3. Der HTML Aufbau - TABLE BASED LAYOUT
      // Wichtig: style="mso-line-height-rule: exactly" zwingt Outlook, die Zeilenhöhe einzuhalten.
      // cellpadding und cellspacing auf 0 verhindern ungewollte Abstände.
      return `
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
  <table border="0" cellpadding="0" cellspacing="0" style="font-family: Arial, Helvetica, sans-serif; font-size: 14px; line-height: 1.4; color: #000000; border-collapse: collapse; mso-table-lspace: 0pt; mso-table-rspace: 0pt;">

    <tr>
      <td style="padding-bottom: 12px; font-weight: 800; font-style: italic;">
        Sportliche Gr&uuml;sse
      </td>
    </tr>

    <tr>
      <td style="padding-bottom: 4px; font-size: 18px; font-weight: 800; font-style: italic; color: #00943c;">
        ${safeName}
      </td>
    </tr>
    <tr>
      <td style="padding-bottom: 12px; font-style: italic; color: #000000;">
        ${safeRole}
      </td>
    </tr>

    <tr>
      <td style="padding-bottom: 12px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 400px;">
          <tr>
            <td style="border-bottom: 2px solid #00943c; font-size: 1px; line-height: 1px;">&nbsp;</td>
          </tr>
        </table>
      </td>
    </tr>

    <tr>
      <td style="padding-bottom: 12px;">
        <img src="${logoUrl}" alt="Logo" width="100" style="display: block; border: 0;" />
      </td>
    </tr>

    <tr>
      <td style="padding-bottom: 12px; font-style: italic;">
        <span style="font-weight: 800; text-transform: uppercase;">
          ${brandTextHtml}
        </span><br>
        ${safeStreet}<br>
        ${safeCity}
      </td>
    </tr>

    <tr>
      <td style="padding-bottom: 15px; font-style: italic;">
        ${safePhoneLabel} <a href="tel:${phoneClean}" style="color: #000000; text-decoration: none;">${this.form.phone}</a><br>
        <a href="mailto:${this.form.email}" style="color: #000000; text-decoration: none;">${this.form.email}</a><br>
        <a href="https://www.wellcomefit.ch" target="_blank" style="color: #00943c; font-weight: 800; text-decoration: none;">www.wellcomefit.ch</a>
      </td>
    </tr>

    <tr>
      <td>
        <a href="https://wellcomefit.ch/signatur" target="_blank" style="text-decoration: none;">
          <img src="${bannerUrl}" width="300" style="display: block; border: 0;" alt="11 Tage kostenlos testen" />
        </a>
      </td>
    </tr>

  </table>`.trim()
    },

    downloadTextFile() {
      const content = this.generateSignatureHTML()
      const safeFilename = this.form.name ? this.form.name.replace(/\s+/g, "_") : "Signatur"
      const filename = `Signatur_Code_${safeFilename}.html` // Endung auf .html geändert für besseres Handling

      // UTF-8 BOM + Content
      const blob = new Blob(["\uFEFF" + content], { type: "text/html;charset=utf-8" })

      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")

      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()

      window.URL.revokeObjectURL(url)
      document.body.removeChild(link)
    },
  },
}
</script>

<style scoped>
.sticky-top {
  position: sticky;
  top: 24px;
}
</style>
